"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterWrapper = exports.BannerWrapper = exports.FormBuilderStepItems = exports.FormBuilderStepContent = exports.FormBuilderStepWrapper = exports.CustomButton = exports.BackButtonContainer = exports.FormBuilderScrollWrapper = exports.FormBuilderWrapper = void 0;
const button_1 = require("@pulse-web-ui/button");
const theme_1 = require("@pulse-web-ui/theme");
exports.FormBuilderWrapper = theme_1.styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ contentWidth }) => contentWidth ? `${contentWidth}px` : '768px'};
  box-sizing: border-box;

  ${theme_1.media.desktopLarge} {
    ${({ isBannerVisible, contentWidth }) => isBannerVisible &&
    (0, theme_1.css) `
        max-width: ${contentWidth ? `${contentWidth + 340}px` : '1108px'};
      `}
  }
`;
exports.FormBuilderScrollWrapper = theme_1.styled.div `
  flex-grow: 1;
  display: flex;
  row-gap: 16px;
  flex-direction: column;
`;
exports.BackButtonContainer = theme_1.styled.div `
  display: flex;
  padding: 20px 16px;
  border-radius: calc(${({ theme }) => theme.common.radius} * 6)
    calc(${({ theme }) => theme.common.radius} * 6) 0 0;
  background: ${({ theme }) => theme.colors.surface.primary};

  ${theme_1.media.desktop} {
    padding: 24px 24px 16px;
  }
`;
exports.CustomButton = (0, theme_1.styled)(button_1.Button) `
  ${theme_1.typography.regular16}
  line-height: 24px;
  position: relative;
  z-index: 1;
`;
exports.FormBuilderStepWrapper = theme_1.styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;

  ${theme_1.media.desktopLarge} {
    flex-direction: row;
  }
`;
exports.FormBuilderStepContent = theme_1.styled.div `
  max-width: ${({ contentWidth }) => contentWidth ? `${contentWidth}px` : '768px'};
  width: 100%;
`;
exports.FormBuilderStepItems = theme_1.styled.div `
  display: flex;
  row-gap: 16px;
  flex-direction: column;

  ${({ isBackButtonVisible }) => isBackButtonVisible &&
    (0, theme_1.css) `
      margin-top: -24px;
      padding-top: 4px;
    `}
`;
exports.BannerWrapper = theme_1.styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  ${theme_1.media.desktopLarge} {
    width: 324px;
    position: sticky;
    top: 16px;
  }
`;
exports.FooterWrapper = theme_1.styled.div `
  margin-top: 16px;
  background: ${({ theme }) => theme.colors.surface.primary};

  ${({ isSticky, theme }) => isSticky &&
    (0, theme_1.css) `
      position: sticky;
      bottom: 0;
      z-index: 1;
      border-radius: calc(${theme.common.radius} * 4)
        calc(${theme.common.radius} * 4) 0 0;
      ${theme.common['box-shadow2']};
      transition: border-radius 0.3s, box-shadow 0.3s;
    `}

  ${({ isDefaultPosition, isSticky }) => (!isSticky || isDefaultPosition) &&
    (0, theme_1.css) `
      border-radius: calc(${({ theme }) => theme.common.radius} * 4);
    `}
`;
